module.exports = __webpack_public_path__ + "img/ubt.6e97e339.svg";